import { AltinnData } from '../reducers/altinnHandling';
import { useAllEmployeeIds, useTaxcardsApi } from './useSalaryTaxCardForReal';
import { useTaxcardSelectableEmployees } from './useTaxcardSelectableEmployees';

export function useEmployeeData(year: number, search: string, sort: string, showHasQuit: boolean, altinn: AltinnData) {
    const taxcardapiparams = {
        year: year.toString(),
        query: search,
        sort: sort,
        hasQuit: false,
        shouldFetch: true,
    };

    // KKINFO, starten av select-all ting
    const selectable = useAllEmployeeIds(taxcardapiparams);
    const taxcardSelectEmployeesMachinery = useTaxcardSelectableEmployees(selectable);
    const selectableQuit = useAllEmployeeIds({
        ...taxcardapiparams,
        hasQuit: true,
        shouldFetch: showHasQuit,
    });
    const taxcardSelectQuitEmployeesMachinery = useTaxcardSelectableEmployees(selectableQuit);

    const employeesTaxcards = useTaxcardsApi(taxcardapiparams, altinn);
    const quitEmployeesTaxcards = useTaxcardsApi(
        {
            ...taxcardapiparams,
            hasQuit: true,
            /* conditional fetching: https://swr.vercel.app/docs/conditional-fetching */
            shouldFetch: showHasQuit,
        },
        altinn,
    );

    return {
        taxcardSelectEmployeesMachinery,
        taxcardSelectQuitEmployeesMachinery,
        employeesTaxcards,
        quitEmployeesTaxcards,
    };
}
